<template>
    <el-tabs v-model="activeName">
<!--        <el-tab-pane label="Helper Company" name="1">-->
<!--            <helper-company></helper-company>-->
<!--        </el-tab-pane>-->
        <el-tab-pane label="Ma Company " name="2">
            <Company></Company>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
    import HelperCompany from "@/view/eazable/company/HelperCompany";
    import Company from "@/view/property/company/Company";

    export default {
        name: "CompanyIndex",
        components: {Company, HelperCompany},
        data() {
            return {
                activeName: "2"
            }
        }
    }
</script>

<style scoped>

</style>
